import React from 'react';

import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import { useCostContext } from './CostProvider';
import { useTranslation } from './i18n';
import { customizedType } from '../helpers/localeHelper';

const AddRelationButton = ({ count, type }) => {
  const { t } = useTranslation();
  const { terminologies } = useCostContext();
  const text = t(`ADD_BUTTON`, {
    count,
    type: customizedType(t, type, terminologies),
  });
  return (
    <div style={{ maxWidth: 180, pointerEvents: 'auto' }}>
      <OverflowTooltip content={text}>{text}</OverflowTooltip>
    </div>
  );
};

export default AddRelationButton;
